import { render, staticRenderFns } from "./Remaining.vue?vue&type=template&id=0cdbe294&scoped=true"
import script from "./Remaining.vue?vue&type=script&lang=js"
export * from "./Remaining.vue?vue&type=script&lang=js"
import style0 from "./Remaining.vue?vue&type=style&index=0&id=0cdbe294&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbe294",
  null
  
)

export default component.exports